import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import {
  mediaReviewFolderKey,
  mediaReviewItemKey,
  type MediaReviewStatus,
} from '../features/files/media-review';

type MediaReviewState = {
  statuses: Record<string, MediaReviewStatus>;
  targets: Record<string, number>;
  setStatus: (userId: string, fileId: string, status: MediaReviewStatus | null) => void;
  setTarget: (userId: string, folderId: string | null, target: number | null) => void;
  resetFolder: (userId: string, folderId: string | null, fileIds: string[]) => void;
};

export const useMediaReviewStore = create<MediaReviewState>()(
  persist(
    (set) => ({
      statuses: {},
      targets: {},
      setStatus: (userId, fileId, status) =>
        set((state) => {
          const key = mediaReviewItemKey(userId, fileId);
          const statuses = { ...state.statuses };
          if (status) statuses[key] = status;
          else delete statuses[key];
          return { statuses };
        }),
      setTarget: (userId, folderId, target) =>
        set((state) => {
          const key = mediaReviewFolderKey(userId, folderId);
          const targets = { ...state.targets };
          if (target === null) delete targets[key];
          else targets[key] = target;
          return { targets };
        }),
      resetFolder: (userId, folderId, fileIds) =>
        set((state) => {
          const statuses = { ...state.statuses };
          for (const fileId of fileIds) delete statuses[mediaReviewItemKey(userId, fileId)];
          const targets = { ...state.targets };
          delete targets[mediaReviewFolderKey(userId, folderId)];
          return { statuses, targets };
        }),
    }),
    {
      name: 'disit-media-review',
      version: 1,
      partialize: ({ statuses, targets }) => ({ statuses, targets }),
    },
  ),
);
